import React from "react";
import styles from "./Eden.module.css";

import edenIntro from "../../../assets/brochure/eden/eden_intro.mp4";
import edenPage02 from "../../../assets/brochure/eden/Eden_01.png";


import edenPage03Bg from "../../../assets/brochure/eden/Asset 23.webp";

import asset25 from "../../../assets/brochure/eden/Asset 25.webp";
import asset26 from "../../../assets/brochure/eden/Asset 26.webp";
import asset27 from "../../../assets/brochure/eden/Asset 27.webp";
import asset28 from "../../../assets/brochure/eden/Asset 28.webp";
import asset29 from "../../../assets/brochure/eden/Asset 29.webp";

import asset1 from "../../../assets/brochure/eden/Asset 1.webp";
import asset2 from "../../../assets/brochure/eden/Asset 2.webp";
import asset3 from "../../../assets/brochure/eden/Asset 3.webp";

import asset7 from "../../../assets/brochure/eden/Asset 7.webp";

import asset11 from "../../../assets/brochure/eden/Asset 11.webp";
import asset12 from "../../../assets/brochure/eden/Asset 12.webp";

import asset13 from "../../../assets/brochure/eden/Asset 13.webp";
import asset14 from "../../../assets/brochure/eden/Asset 14.webp";

import asset15 from "../../../assets/brochure/eden/Asset 15.webp";
import asset16 from "../../../assets/brochure/eden/Asset 16.webp";

import asset17 from "../../../assets/brochure/eden/Asset 17.webp";
import asset18 from "../../../assets/brochure/eden/Asset 18.webp";
import asset19 from "../../../assets/brochure/eden/Asset 19.webp";
import asset20 from "../../../assets/brochure/eden/Asset 20.webp";
import asset21 from "../../../assets/brochure/eden/Asset 21.webp";

import group11 from "../../../assets/brochure/eden/Group 11.webp";

import asset22 from "../../../assets/brochure/eden/Asset 22.webp";


const Eden = () => {

  const page03Features = [
    {
      icon: asset25,
      lines: ["Flexible", "SL frame"],
    },
    {
      icon: asset26,
      lines: ["active arm", "robotics", "technology"],
    },
    {
      icon: asset27,
      lines: ["EDEN’s", "core stimulation", "program"],
    },
    {
      icon: asset28,
      lines: ["Sensible", "modern", "design"],
    },
    {
      icon: asset29,
      lines: ["Convenience", "features", "for users"],
    },
  ];


  const edenCareModes = [
    {
      icon: asset17,
      lines: ["FULL BODY", "REFRESH"],
    },
    {
      icon: asset18,
      lines: ["FULL BODY", "RECOVERY"],
    },
    {
      icon: asset19,
      lines: ["FULL BODY", "RELAXATION"],
    },
    {
      icon: asset20,
      lines: ["NECK AND", "SHOULDER FOCUS"],
    },
    {
      icon: asset21,
      lines: ["UPPER BODY", "FOCUS"],
    },
  ];


  return (
    <div className={styles.edenBrochure}>

      {/* =====================================================
          PAGE 01 — INTRO VIDEO
      ===================================================== */}

      <section className={styles.page01}>
        <video
          className={styles.page01Video}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        >
          <source src={edenIntro} type="video/mp4" />
        </video>
      </section>


      {/* =====================================================
          PAGE 02 — EDEN'S HIGHLIGHTS
          Original Brochure Image
      ===================================================== */}

      <section className={styles.page02}>
        <img
          className={styles.page02Image}
          src={edenPage02}
          alt="EDEN's Highlights"
        />
      </section>


      {/* =====================================================
          PAGE 03 — EDEN'S HIGHLIGHTS
      ===================================================== */}

      <section className={styles.page03}>

        {/* Background */}
        <img
          className={styles.page03Bg}
          src={edenPage03Bg}
          alt=""
        />


        {/* Header */}
        <div className={styles.page03Header}>

          <div className={styles.page03Eyebrow}>
            EDEN'S HIGHLIGHTS
          </div>

          <div className={styles.page03CheckPoint}>
            <span className={styles.page03LargeCheck}></span>

            <span>
              5 CHECK POINT
            </span>
          </div>

          <h2>
            FOR EDEN WITH
            <br />
            INNOVATIVE TECHNOLOGY
          </h2>

        </div>


        {/* Bottom Features */}
        <div className={styles.page03Features}>

          {page03Features.map((feature, index) => (
            <div
              className={styles.page03Feature}
              key={index}
            >

              <div className={styles.page03SmallCheck}></div>

              <img
                src={feature.icon}
                alt=""
                className={styles.page03FeatureIcon}
              />

              <p>
                {feature.lines.map((line, lineIndex) => (
                  <React.Fragment key={lineIndex}>
                    {line}
                    {lineIndex !== feature.lines.length - 1 && <br />}
                  </React.Fragment>
                ))}
              </p>

            </div>
          ))}

        </div>

      </section>


      {/* =====================================================
          PAGE 04 — ROBOTICS / EDEN CARE
      ===================================================== */}

      <section className={styles.page04}>


        {/* ===================================================
            INTRO
        =================================================== */}

        <div className={styles.page04Intro}>

          <div className={styles.page04Tags}>
            <span># Robotics</span>
            <span># Technology</span>
            <span># XD-Pro</span>
          </div>


          <h2>
            ROBOTICS TECHNOLOGY
            <br />
            IN A NEW CONCEPT
          </h2>


          <p>
            INNOVATIVE TECHNOLOGY COMBINES THE BENEFITS
            <br />
            OF BOTH THE MASSAGE CHAIR AND MASSAGE BED
          </p>

        </div>


        {/* ===================================================
            FLEXIBLE SL FRAME
            IMAGE RIGHT / TEXT LEFT
        =================================================== */}

        <div
          className={`${styles.page04TechBlock} ${styles.page04TechRight}`}
        >

          <img
            src={asset1}
            alt="Flexible SL Frame"
            className={styles.page04TechImage}
          />


          <div
            className={`${styles.page04TechCopy} ${styles.page04CopyLeft}`}
          >

            <h3>
              FREELY FLEXIBLE SL FRAME
            </h3>


            <p>
              Comfortable as like a bed with a full-flat posture freely lying
              down and sitting up Get an effective massage while lying down.
            </p>

          </div>

        </div>


        {/* ===================================================
            ACTIVE ARM
            IMAGE LEFT / TEXT RIGHT
        =================================================== */}

        <div
          className={`${styles.page04TechBlock} ${styles.page04TechLeft}`}
        >

          <img
            src={asset2}
            alt="Active Arm"
            className={styles.page04TechImage}
          />


          <div
            className={`${styles.page04TechCopy} ${styles.page04CopyRight}`}
          >

            <h3>
              ACTIVE ARM ROBOTICS TECHNOLOGY
            </h3>


            <p>
              Since it holds your arms stably while moving along the diagonal
              sliding structure, you can receive a comfortable arm massage even
              while lying down.
            </p>

          </div>

        </div>


        {/* ===================================================
            XD-PRO
            IMAGE RIGHT / TEXT LEFT
        =================================================== */}

        <div
          className={`${styles.page04TechBlock} ${styles.page04TechRight}`}
        >

          <img
            src={asset3}
            alt="XD-Pro"
            className={styles.page04TechImage}
          />


          <div
            className={`${styles.page04TechCopy} ${styles.page04CopyLeft}`}
          >

            <h3>
              XD-PRO MASSAGE MODULE
            </h3>


            <p>
              The XD-PRO heating module that moves in 60 increments of 1.25mm
              provides massage as precise as a human hand.
            </p>

          </div>

        </div>


        {/* ===================================================
            EDEN CARE MASSAGE
        =================================================== */}

        <div className={styles.page04CareHero}>

          <img
            src={asset7}
            alt="Eden Care Massage"
          />

        </div>


        {/* ===================================================
            FULL BODY SPECIALIZED EDEN CARE
        =================================================== */}

        <div className={styles.page04CareHeading}>

          <div className={styles.page04CareTags}>
            <span># Roll-back</span>
            <span># Core-Stretching</span>
            <span># Relaxation</span>
          </div>


          <h2>
            FULL BODY SPECIALIZED
            <br />
            EDEN CARE
          </h2>


          <p>
            EDEN'S EXCLUSIVELY
            <br />
            SPECIAL TOTAL MASSAGE PROGRAM
          </p>

        </div>


        {/* ===================================================
            ROLLBACK STRETCH
        =================================================== */}

        <div className={styles.page04CareFeature}>

          <img
            src={asset11}
            alt="Rollback Stretch"
            className={styles.page04CareImage}
          />


          <div className={styles.page04CareInfo}>

            <div className={styles.page04CareText}>

              <h3>
                ROLLBACK STRETCH
              </h3>


              <p>
                The motion is inspired by a Pilates movement 'Cadilac Rollback'.
                This mode provides abdominal and spinal segment movements and arm
                stretching by holding and stretching the arms.
              </p>

            </div>


            <img
              src={asset12}
              alt=""
              className={styles.page04CareIcon}
            />

          </div>

        </div>


        {/* ===================================================
            FULL BODY CORE STRETCH
        =================================================== */}

        <div className={styles.page04CareFeature}>

          <img
            src={asset13}
            alt="Full Body Core Stretch"
            className={styles.page04CareImage}
          />


          <div className={styles.page04CareInfo}>

            <div className={styles.page04CareText}>

              <h3>
                FULL BODY CORE STRETCH
              </h3>


              <p>
                A specialized massage program that only Eden can implement.
                this mode lowers the leg angle under the full body in a flat state
                to stimulate and stretch the abdominal and core muscles.
              </p>

            </div>


            <img
              src={asset14}
              alt=""
              className={styles.page04CareIcon}
            />

          </div>

        </div>


        {/* ===================================================
            COMFORTABLE WAIST
        =================================================== */}

        <div className={styles.page04CareFeature}>

          <img
            src={asset15}
            alt="Comfortable Waist"
            className={styles.page04CareImage}
          />


          <div className={styles.page04CareInfo}>

            <div className={styles.page04CareText}>

              <h3>
                COMFORTABLE WAIST
              </h3>


              <p>
                This mode uses the massage module to form a C-curve for easy
                beck traction, focusing on the muscles around the waist to massage
                and relax them.
              </p>

            </div>


            <img
              src={asset16}
              alt=""
              className={styles.page04CareIcon}
            />

          </div>

        </div>


        {/* ===================================================
            5 EDEN CARE MODES
            3 TOP + 2 BOTTOM
        =================================================== */}

        <div className={styles.page04Modes}>

          {edenCareModes.map((mode, index) => (
            <div
              className={styles.page04Mode}
              key={index}
            >

              <img
                src={mode.icon}
                alt=""
              />


              <p>
                {mode.lines.map((line, lineIndex) => (
                  <React.Fragment key={lineIndex}>

                    {line}

                    {lineIndex !== mode.lines.length - 1 && (
                      <br />
                    )}

                  </React.Fragment>
                ))}
              </p>

            </div>
          ))}

        </div>


        {/* ===================================================
            DESIGN & HARMONY
            GROUP 11 BACKGROUND
        =================================================== */}

        <div className={styles.page04DesignHarmony}>

          <img
            src={group11}
            alt=""
            className={styles.page04DesignHarmonyBg}
          />


          {/* PERFECT HARMONY HEADING */}

          <div className={styles.page04DesignHeading}>

            <h2>
              PERFECT HARMONY OF
              <br />
              DESIGN AND RELAXATION
            </h2>


            <p>
              EDEN DEMONSTRATES THE BEAUTY OF A
              <br />
              MODERN LIFESTYLE AND CUTTING-EDGE TECHNOLOGY
            </p>

          </div>


          {/* DESIGN DESCRIPTION */}

          <div className={styles.page04DesignText}>

            <p>
              The slash LED that moves while emitting light expresses Eden's
              <br />
              sliding motion and technology and presents luxurious details.
            </p>

          </div>


          {/* HARMONY DESCRIPTION */}

          <div className={styles.page04HarmonyText}>

            <p>
              The exterior color blends in harmony with the existing interior.
              <br />
              The warm ivory color is used for the sheet to create a
              <br />
              modern and clean mod.
            </p>

          </div>

        </div>


        {/* ===================================================
            HEATING FUNCTION
        =================================================== */}

        <div className={styles.page04Heating}>

          <img
            src={asset22}
            alt="Eden Heating Function"
            className={styles.page04HeatingBg}
          />


          <div className={styles.page04HeatingText}>

            <h2>
              AFFORDABLE PTC*
              <br />
              HEATING FUNCTION
            </h2>


            <p>
              Equipped on the back and calves, the fast-heating, long-lasting
              <br />
              and affordable heating function adjusts the temperature up to 50C.
            </p>

          </div>


          <div className={styles.page04HeatingNote}>

            <p>
              * The PTC (Positive Temperature Coefficients) is a safe heating
              elements thst shuts
              <br />
              off the current when specific temperature is reached. It has the
              advantage of gradually reducing power consumption.
            </p>

          </div>

        </div>


      </section>

    </div>
  );
};


export default Eden;